import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/establishments`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/establishments/${id}?include=organization,tags,allowedLocations,serviceCenter,customer,allowedUsers,allowedUsers.roles,coordinator,managers`,
      options
    )
    .then((response) => {
      let establishment = jsona.deserialize(response.data);
      delete establishment.links;
      return establishment;
    });
}

function add(establishment) {
  const payload = jsona.serialize({
    stuff: establishment,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/establishments?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(establishment) {
  const payload = jsona.serialize({
    stuff: establishment,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/establishments/${establishment.id}?include=`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/establishments/${id}`, options);
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/establishments/${id}/activate?include=organization,tags,allowedLocations,serviceCenter,customer,allowedUsers,allowedUsers.roles,coordinator,managers`,
      options
    )
    .then((response) => {
      let establishment = jsona.deserialize(response.data);
      delete establishment.links;
      return establishment;
    });
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/establishments/${id}/deactivate?organization,tags,allowedLocations,serviceCenter,customer,allowedUsers,allowedUsers.roles,coordinator,managers`,
      options
    )
    .then((response) => {
      let establishment = jsona.deserialize(response.data);
      delete establishment.links;
      return establishment;
    });
}

function pendingSummary(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/establishments/${id}/pending-summary`, options)
    .then((response) => {
      return response.data.data;
    });
}

function couponsBalance({ id, asOf }) {
  const options = {
    params: asOf ? { as_of: asOf } : {},
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/establishments/${id}/coupons-balance`, options)
    .then((response) => {
      return response.data.data;
    });
}

function directory(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios
    .get(`${url}/establishments/directory`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function printDirectory(params) {
  const options = {
    headers: {},
    responseType: "blob",
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/establishments/directory/print`, options);
}

function istheraProducts(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/establishments/${id}/isthera-products`, options)
    .then((response) => response.data);
}

function istheraProvision({ id, dryRun, purge }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/establishments/${id}/isthera-provision`,
      { dry_run: !!dryRun, purge: !!purge },
      options
    )
    .then((response) => response.data.data);
}

function istheraDeactivateUnlinked({ id, dryRun }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/establishments/${id}/isthera-deactivate-unlinked`,
      { dry_run: !!dryRun },
      options
    )
    .then((response) => response.data.data);
}

function istheraSyncProduct({ id, productId }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/establishments/${id}/isthera-sync-product`,
      { product_id: productId },
      options
    )
    .then((response) => response.data.data);
}

function istheraDeactivateProduct({ id, codeAchat }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/establishments/${id}/isthera-deactivate-product`,
      { code_achat: codeAchat },
      options
    )
    .then((response) => response.data.data);
}

function istheraProvisionStatus({ id, runId }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: runId ? { run_id: runId } : {},
  };

  return axios
    .get(`${url}/establishments/${id}/isthera-provision-status`, options)
    .then((response) => response.data.data);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  activate,
  deactivate,
  pendingSummary,
  couponsBalance,
  directory,
  printDirectory,
  istheraProducts,
  istheraProvision,
  istheraProvisionStatus,
  istheraDeactivateUnlinked,
  istheraSyncProduct,
  istheraDeactivateProduct,
};
